import React, { useContext, useState } from 'react';
import Button from '@mui/material/Button';
import Select from 'react-select';
import StoreContext from '../context/StoreContext';
import UserContext from '../context/UserContext';
import PropTypes from 'prop-types';
import FeedbackContext from '../context/FeedbackContext';

const StoreSelector = ({
  closeModal,
}) => {
  const { storeList } = useContext(StoreContext);
  const [selectedStore, setSelectedStore] = useState('');
  const { updateStore } = useContext(StoreContext);
  const { isAdmin } = useContext(UserContext);
  const { setIsLoading } = useContext(FeedbackContext)

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (selectedStore) {
      localStorage.removeItem('currentStoreId')
      setIsLoading(true)
      await updateStore(selectedStore.value, isAdmin);
      closeModal();
    }
  };

  return (
    <div
      className="modal-dialog"
      role="dialog"
      aria-labelledby="dialogStoreSelectorTitle"
    >
      <div className="modal-header">
        <h2 id="dialogStoreSelectorTitle">Select Store</h2>
      </div>
      <div className="modal-body">
        <div className="select-element">
          <Select
            styles={customStyles}
            isSearchable
            value={selectedStore}
            options={storeList}
            onChange={(selected) => setSelectedStore(selected)}
          />
        </div>
        <form onSubmit={handleSubmit}>
          <br />
          <br />
          <Button type="submit" variant="contained" color="primary">
            Submit
          </Button>
        </form>
      </div>
      <div className="modal-footer" />
    </div>
  );
};

const customStyles = {
  control: (styles, { isFocused }) => ({
    ...styles,
    border: 'none',
    borderBottom: '1px solid #000000',
    borderRadius: 0,
    outline: isFocused ? 0 : 0,
    fontSize: '1.2em',
  }),
  container: (styles) => ({
    ...styles,
    width: '70%',
    zIndex: '10',
  }),
  modalContentContainer: {
    width: '40%',
    backgroundColor: 'white',
    margin: '0 auto',
    borderColor: 'white',
    outline: 'none !important',
  },
};

StoreSelector.propTypes = {
  stores: PropTypes.array,
  closeModal: PropTypes.func,
  setChangeStoreFlag: PropTypes.func
};

export default StoreSelector;
